// helper for browser usage
const {$} = window
let lang = window.lang || 'cs'

export function __(key) {
  if (process.env.NODE_ENV === 'production')
    return window.translatedLocales[lang][key] || key
  const translation = window.translatedLocales[lang][key]
  if (!translation) {
    console.log("adding new translation", translation, key)
    $.ajax({
      url: '/api/translations',
      data: {toTranslate: key},
      success: (data, status) => {
        if (status != 'success') {
          console.log('ERROR', status, data);
          return
        }
      console.log(status, data);
      }
    });
  }
  return translation || key
}



// WEBPACK FOOTER //
// ./src/server/lib/i18n-2/browserHelper.js